export default {
  videos: [],
  filteredVideos: [],
  selectedVideos: [],
  allVideosLoaded: false,
  totalVideos: 0,
  currentFolderId: 0,
}
